import { Container } from '@mui/material';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';

class PrimeraVez extends Component {
    constructor(props){
        super(props);
        this.state = {
            cambio: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
                password: '',
                passwordConfirmada: '',
            },
            cambioOK: false,
            notificaciones: null,
            errores: null,
        }
        this.controlarCambios = this.controlarCambios.bind(this);
        this.manejarEnvioDatos = this.manejarEnvioDatos.bind(this);
    }

    async componentDidMount(){}

    render(){
        return (
            <>
                {sessionStorage.login
                ?
                    <Container>
                            <div className='mt-5'>
                                <h3 className='text-center'>CAMBIO DE CONTRASEÑA</h3>
                                <hr />
                                <div className='row justify-content-center'>
                                    <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                                        <form onSubmit={this.manejarEnvioDatos}>
                                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                            <input type="password" className='form-control mb-2' placeholder='INGRESE NUEVA CONTRASEÑA' id='password' onChange={this.controlarCambios} value={this.state.cambio.password}/>
                                            <input type="password" className='form-control mb-2' placeholder='CONFIRMAR NUEVA CONTRASEÑA' id='passwordConfirmada' onChange={this.controlarCambios} value={this.state.cambio.passwordConfirmada}/>
                                            <button className='btn btn-outline-dark btn-lg btn-block'>CONFIRMAR</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                    </Container>
                :
                    <Redirect to='/login'/>
                }
                {sessionStorage.login && this.state.cambioOK
                ?
                    <Redirect to='/inicio'/>
                :
                    null
                }
            </>
        )//Final return
    }//Final render

    controlarCambios(e){
        e.preventDefault()
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const registroActualizado = state.cambio;
            registroActualizado[clave] = valor;
            return{
                registro: registroActualizado,
            };
        })
    }

    async manejarEnvioDatos(e){
        e.preventDefault();
        if(this.state.cambio.password === ''){
            this.setState({
                errores: 'Debe ingresar la nueva contraseña!'
            });
        }else if(this.state.cambio.passwordConfirmada === ''){
            this.setState({
                errores: 'Debe confirmar la nueva contraseña!'
            });
        }else if(this.state.cambio.passwordConfirmada !== this.state.cambio.password){
            this.setState({
                errores: 'Las contraseñas deben coincidir!'
            });
        }else{
            const cargaUtil = JSON.stringify(this.state.cambio);

            const respuesta = await fetch(`${Constantes.RUTA_API}/cambio_contrasenia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito.length !== 0){
                this.setState({
                    notificaciones: 'La contraseña fue actualizada correctamente!',
                    cambio: {
                        numeroFuncionario: '',
                        password: '',
                        nombreFuncionario: '',
                        passwordConfirmada: '',
                    },
                    cambioOK: true,
                })
                sessionStorage.removeItem('primeraVez');
                sessionStorage.setItem('primeraVez', '0');
            }else{
                this.setState({
                    errores: 'La contraseña no fue actualizada!',
                })
            }
        }
    }
}

export default PrimeraVez